<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div class="user-main-right">
        <h3 class="info-title">修改手机号</h3>
        <div class="change-pass-box">
          <div class="info-modify-div">
            <span class="info-modify-txt">当前手机号：</span>
            <div class="nickname">
              <input type="tel" class="nickname-input" :class="{err:error_type == '3'}" placeholder="请输入手机号" v-model="registerInput.phone" oninput="this.value=this.value.replace(/\D/g,'')"  maxlength="11" @click="cleanError">
            </div>
            <p class="err-txt" v-if="error_type == '3'"></p>
          </div>

          <div class="info-modify-div clearfix">
            <span class="info-modify-txt fl">新手机号：</span>
            <div class="nickname fl" style="margin-left: 4px;">
              <input type="tel" class="nickname-input fl" :class="{err:error_type == '1'}" placeholder="请输入手机号" v-model="registerInput.newPhone" oninput="this.value=this.value.replace(/\D/g,'')"  maxlength="11" @click="cleanError">
            </div>
            <p class="err-txt fl" v-if="error_type == '1'">{{error_content}}</p>
          </div>

          <div class="info-modify-div clearfix">
            <span class="info-modify-txt fl">新手机验证码：</span>
            <div class="nickname fl">
              <input class="nickname-input" style="margin-left: 4px;"  placeholder="请输入新手机验证码" v-model="registerInput.newcode" maxlength="4" @click="cleanError" @change="telInputFun" >
              <a href="javascript:void (0)" v-show="sendAuthCode" class="auth_text auth_text_blue"  @click="getAuthCode()">获取验证码</a>
              <p v-show="!sendAuthCode" class="auth_text"> <span class="auth_text_blue">{{auth_time}} </span>秒后可重新获取</p>
            </div>
            <div v-if="showError" class="fl" style="margin-left: 15px;color:#ff0000 ">验证码错误</div>
          </div>
          <div class="error_content" v-if="error_txt != ''">{{error_content}}</div>
          <div class="info-modify-div">
            <span class="info-modify-txt"></span>
            <div class="preservation-btn" @click="saveSetting">保存设置</div>
          </div>
        </div>
      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/tjs/tool'
  import axios from 'axios'
  export default {
    name: "phonenum",
    data () {
      return {
        navActive:3,
        userNav:3,
        registerInput:{
          phone:'',//当前电话
          newPhone:'',//新电话
          newcode:'',//注册验证码
          auth_timetimer:null  /*定时器定义成全局变量 可以在一个函数如何停止另一个函数里的定时器*/
        },
        telNum:"",  //手机号
        sendAuthCode:true, /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
        auth_time: 60,  /*倒计时 计数器*/
        auth_timetimer:null,  /*定时器定义成全局变量 可以在一个函数如何停止另一个函数里的定时器*/
        error_type:0, /*0:无错误；1：未填写当前手机号；2：未填新手机号； 3：未填写验证码*/
        error_content:'',/*错误内容*/
        error_txt:'',//后台返回的错误提示
        showError:false,
        flag:0
      }
    },
    components: {
      UserNav,
      navCom,
      footerCom
    },
    computed:{
      ...mapState(['uuid','headUserName'])
    },
    methods: {
      ...mapMutations(['logOrRegFun','changeheadUserName']),
      restart(e){
        this.sendAuthCode = e;
        this.auth_time=this.auth_time-1;
        var auth_timetimer = setTimeout(() => {
          if (this.auth_time <= 0) {
            clearTimeout(auth_timetimer);
            this.sendAuthCode = true;
            this.flag =0
          }else {
            this.restart(e);
          }
        }, 1000);
        this.flag = 1;
      },
      //  点击获取验证码
      getAuthCode: function () {
        //   手机号为空
        if(this.registerInput.newPhone == ''){
          this.error_type = 1
          this.error_content = '请输入手机号哟！↖(￣▽￣") '
        }else{
          this.error_content =''
          var that=this
          let data = {
            tel: this.registerInput.newPhone,
            type:2
          };
          axios.post('/api/Login/getCode' , data)
            .then(function (res) {
              /** 成功 : 1 **/
              if (res.data.code == 200&&that.flag == 0) {
                that.auth_time=60;
                that.restart(false);
                that.$toast.center(res.data.msg);
              }
              /** 失败 : 0/3 **/
              else {
                /** 提示错误信息 : 0  **/
                if (res.data.code == 400) {
                  that.$toast.center(res.data.msg);
                }
              }
            })
        }
      },
//      打印出我们储存的电话号码
      telInputFun: function () {
        console.log(this.telNum)
      },

      /*清除错误样式*/
      cleanError: function () {
        this.error_type = 0;
        this.error_content = '';
        this.error_txt = ''
      },
      /*保存设置*/
      saveSetting: function (e) {
        let that = this;
        if (that.error_type == 0) {
          if (!this.registerInput.phone){
            this.$toast.center("请输入当前手机号");
            return;
          }
          if (!this.registerInput.newPhone){
            this.$toast.center("请输入新手机号");
            return;
          }
          if (!this.registerInput.newcode){
            this.$toast.center("请输入验证码");
            return;
          }
          let data = {
            now_tel: this.registerInput.phone,
            tel: this.registerInput.newPhone,
            user_id: this.$store.state.uuid,
            code: this.registerInput.newcode,
          };
          axios.post('/api/Center_User/editTel' , data)
            .then(function (res) {
              /** 成功 : 1 **/
              if (res.data.code == 200) {
                  console.log('手机号',res)
                  that.changeheadUserName(that.registerInput.newPhone);
                  that.auth_time=0;
                  that.restart(true);
                  that.$toast.center(res.data.msg);
                  that.sendAuthCode = true;
                  that.registerInput.phone='';//当前电话
                  that.registerInput.newPhone='';//新电话
                  that.registerInput.newcode='';//注册验证码
              }
              /** 失败 : 0/3 **/
              else {
                /** 提示错误信息 : 0  **/
                if (res.data.code == 400) {
                  that.$toast.center(res.data.msg);
                }
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    }
  }
</script>

<style scoped>
  .w{
    width: 1200px;
    margin: 0 auto ;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .all-whole{
    background: #fbfbfb;
  }
  .user-main-right{
    width: 1000px;
    float: right;
    height: 720px;
    background: #ffffff;
  }
  .info-title{
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
  }
  .info-modify-div{
    margin-top: 30px;
    font-size: 16px;
    line-height: 35px;
  }
  .info-modify-div .err-txt{
    position: initial;
    color:#fe4444 ;
    margin-left: 10px;
  }
  .info-modify-txt{
    color: #6c6c6c;
    font-size: 16px;
    width: 160px;
    display: inline-block;
    text-align: right;
  }
  .default-head img{
    width: 100%;
    height: 100%;
  }
  .default-head-info p{
    font-size: 14px;
    color: #fff;
    line-height: 88px;
    text-align: center;
  }
  .default-head-info input{
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 88px;
    height: 88px;
    cursor: pointer;
    color:#d0d0d0;
  }
  .nickname ::-webkit-input-placeholder { /* WebKit browsers */
    color:    #d0d0d0;
  }
  .nickname :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:    #d0d0d0;
  }
  .nickname ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:    #d0d0d0;
  }
  .nickname :-ms-input-placeholder { /* Internet Explorer 10+ */
    color:    #d0d0d0;
  }
  .nickname{
    width: 308px;
    height: 35px;
    display: inline-block;
    position: relative;
  }
  .nickname-input{
    width: 308px;
    height: 35px;
    border: 1px solid #e3e3e3;
    font-size: 14px;
    color: #6c6c6c;
    padding-left: 10px;
    box-sizing: border-box;
    outline: none;
  }
  .input-select-div input[type="radio"],.input-select-div input[type="checkbox"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }
  .input-select-div span{
    margin-left: 10px;
    color: #878787;
    font-size: 16px;
    font-weight: 500;
  }
  .input-select-div label {
    position: absolute;
    left: 5px;
    top: 6px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid #999;
  }
  /*设置选中的input的样式*/
  /* + 是兄弟选择器,获取选中后的label元素*/
  .input-select-div input:checked+label::after {
    position: absolute;
    content: "";
    width: 7px;
    height: 7px;
    top: 4px;
    left: 4px;
    background: #ff0100;
    border-radius: 50%;
  }
  .drop-down-item span{
    line-height: 35px;
    color: #6c6c6c;
    font-size: 14px;
    padding-left: 5px;
    box-sizing: border-box;
    width: 126px;
    display: inline-block;
    cursor: pointer;
  }
  .grade-item span{
    width: 289px;
    height: 32px;
  }
  .drop-down-item i{
    border: 6px solid transparent;
    border-top-color: #bfbfbf;
    vertical-align: bottom;
    position: relative;
    top: 2px;
  }
  .drop-down-choose p{
    line-height: 35px;
    font-size: 14px;
    color: #6c6c6c;
    padding-left: 5px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .drop-down-choose p:hover{
    background: #e3e3e3;
  }
  .info-modify-div{
    margin-top: 30px;
    position: relative;
  }
  .info-modify-txt{
    width: 150px;
    text-align: right;
    display: inline-block;
    margin-right: 15px;
  }
  .preservation-btn{
    width: 313px;
    height: 54px;
    background: #1a71ff;
    font-size: 16px;
    color: #fff;
    line-height: 54px;
    text-align: center;
    margin-top: 58px;
    display: inline-block;
    cursor: pointer;
  }
  .nickname .nickname-input-active{
    border-color:#ff0100
  }
  .info-modify-div{
    position: relative;
  }
  .info-modify-div a,.info-modify-div p{
    position:absolute;
    top: 0;
    display:block;
    right: 10px;
    color:#1a71ff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/user-phoneNum.vue